export default "__VITE_ASSET__BE5$6V7G__"